import { Permissions, security } from "Common/permissions";
import { PageObject, ROUTE_ANCHOR, registerRouting } from "Common/routingUtils";
import ProjectDetails from "./projectDetails";
import hashes from "./routesMap.hash";
import locale from "./routesMap.locale";
import routingKeys from "./routingKeys";
if (security.isAllowed([Permissions.ProjectsView])) {
    registerRouting(routingKeys.PROJECT_DETAILS, new PageObject(ProjectDetails, {
        hash: `${hashes.PROJECT_DETAILS}/(?<id>(?!0+$)\\d+)`,
        locale: locale.PROJECT_DETAILS
    }, null, false, id => {
        if (!Number.isFinite(Number(id)) || id <= 0)
            return null;
        return `${ROUTE_ANCHOR}${hashes.PROJECT_DETAILS}/${id}`;
    }));
}
